import { List, ListItem } from "@mui/material";
import MDBadgeDot from "components/MDBadgeDot";
//import Badge from "components/Badge";
import React from "react";
//import MDBadge from "components/MDBadge";
import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";

export function SimpleList({ colors, labels }) {
  console.log(colors);
  return (
    <List dense={true}>
      {labels.map((label, index) =>
        React.cloneElement(
          <ListItem>
            <MDBadgeDot
              variant="gradient"
              color={colors[index]}
              size="sm"
              badgeContent={<MDTypography variant="caption">{label}</MDTypography>}
            ></MDBadgeDot>
          </ListItem>,
          {
            key: index,
          }
        )
      )}
    </List>
  );
}

SimpleList.defaultProps = {
  colors: [],
  labels: [],
};
SimpleList.propTypes = {
  colors: PropTypes.array,
  labels: PropTypes.array,
};
